import { LOCALES } from "../../../i18n";
import { CHANGE_LANG } from "../actions";

const initialState = {
  lang: localStorage.getItem("preferredLang") || LOCALES.SPANISH,
};

function languageReducer(state = initialState, action) {
  const lang =
    state.lang === LOCALES.ENGLISH ? LOCALES.SPANISH : LOCALES.ENGLISH;

  switch (action.type) {
    case CHANGE_LANG: {
      localStorage.setItem("preferredLang", lang);
      return {
        ...state,
        lang,
      };
    }
    default: {
      return state;
    }
  }
}
export default languageReducer;
